import React, { useEffect, useState, useCallback } from 'react';
import { referencesAPI } from '../services/api';

const ReferencesList = () => {
  const [refs, setRefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadReferences = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await referencesAPI.list();
      const data = res.data?.data || res.data || [];
      setRefs(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Erro ao carregar referências');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadReferences(); }, [loadReferences]);

  const deleteReference = async (r) => {
    const name = r?.title || (r?.type === 'url' ? r?.value : r?.file_name || r?.value) || `ID ${r?.id}`;
    const confirmed = window.confirm(`Deseja excluir a referência "${name}"?`);
    if (!confirmed) return;
    try {
      const res = await referencesAPI.remove(r.id);
      if (res.status >= 200 && res.status < 300) {
        alert('Referência excluída com sucesso.');
        await loadReferences();
      } else {
        alert(res?.data?.error || 'Falha ao excluir referência');
      }
    } catch (e) {
      alert(e?.response?.data?.error || e.message || 'Erro ao excluir referência');
    }
  };

  return (
    <div className="references-page">
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>📚 Referências (Fontes)</h2>
        <button className="page-btn" onClick={loadReferences}>Atualizar</button>
      </div>

      {loading && (
        <div className="loading" style={{ marginTop: '1rem' }}>Carregando referências...</div>
      )}
      {error && (
        <div className="error" style={{ color: '#dc3545', marginTop: '1rem' }}>{error}</div>
      )}

      {!loading && refs.length === 0 && !error && (
        <div className="empty-state" style={{ marginTop: '1rem', color: '#666' }}>Nenhuma referência cadastrada.</div>
      )}

      {!loading && refs.length > 0 && (
        <div className="card" style={{ marginTop: '1rem' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Tipo</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Título</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Valor</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Criado</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #eee' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {refs.map((r) => (
                  <tr key={r.id}>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{(r.type || '').toUpperCase()}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{r.title || '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>
                      {r.type === 'url' ? (r.value || '-') : (r.file_name || r.value || '-')}
                    </td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>{r.created_at ? new Date(r.created_at).toLocaleString('pt-BR') : '-'}</td>
                    <td style={{ padding: '8px', borderBottom: '1px solid #f4f4f4' }}>
                      <button 
                        className="page-btn" 
                        onClick={() => deleteReference(r)} 
                        style={{ background: '#dc3545', borderColor: '#dc3545' }}
                        title="Excluir"
                      >
                        Excluir
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReferencesList;